/* eslint-disable @typescript-eslint/no-explicit-any */
import classes from './CellPublicOffsetsActions.module.css';
import { Box, rem, Image } from '@mantine/core';
import { Menu, ActionIcon } from '@mantine/core';
import IconDotsVertical from '@assets/icons/dots-vertical.svg';
import IconExternalLink from '@assets/icons/external-link.svg';

import styles from './CellPublicOffsetsActions.module.css';
import { useTranslation } from 'react-i18next';
import { TOffset } from '@features/offsets/types';

export const CellPublicOffsetsActions = (props: {
	handleviewmore: (data: TOffset) => void;
	handledownload: (id: string, lang: string) => void;
	row?: any;
	opened?: boolean;
	enableCertification?: boolean;
	enableOffset?: boolean;
}) => {
	const { t } = useTranslation();
	return (
		<Box
			style={{
				display: 'flex',
				width: '26px',
				height: '25px',
			}}
		>
			<Menu
				opened={props.opened}
				shadow="xs"
				classNames={styles}
			>
				<Menu.Target>
					<ActionIcon
						data-testid="W2FtAXR6_Z5jdHi6B-menu"
						variant="transparent"
						className={classes.customSize}
						onClick={(event) => {
							event.stopPropagation();
						}}
					>
						<Image
							style={{
								objectFit: 'contain',
								width: rem(25),
								height: rem(25),
							}}
							src={IconDotsVertical}
						/>
					</ActionIcon>
				</Menu.Target>
				<Menu.Dropdown>
					<Menu.Label>{t('global.offset')}</Menu.Label>
					<Menu.Item
						data-testid="W2FtAXR5_Z5jdHi6B-menu"
						onClick={(event) => {
							event.stopPropagation();
							if (props && props.row) {
								props.handleviewmore(props.row);
							}
						}}
						color="var(--mantine-color-black)"
						className={styles.item}
						leftSection={
							<Image
								style={{
									objectFit: 'contain',
									width: rem(20),
									height: rem(20),
								}}
								src={IconExternalLink}
							/>
						}
					>
						{t('global.viewMore')}
					</Menu.Item>
				</Menu.Dropdown>
			</Menu>
		</Box>
	);
};
